
import { Component, Vue } from 'vue-property-decorator'
import { mapActions, mapState } from 'vuex'
import keyCodeMapperCharacter from '@/utils/keycodemap.utils'
import * as onScan from 'onscan.js'
import ProductProvider from '@/resources/product.provider'
import StockLocationProvider from '@/resources/stock-location.provider'

@Component({
  components: {},
  computed: {
    ...mapState({
      selectBranch: (state: any) => state.Store.selectBranch,
      products: (state: any) => state.LocationManagement.products,
      currentStep: (state: any) => state.LocationManagement.currentStep,
      origin: (state: any) => state.LocationManagement.origin,
      destination: (state: any) => state.LocationManagement.destination
    })
  },
  methods: {
    ...mapActions({
      setProduct: 'LocationManagement/setProduct',
      addProduct: 'LocationManagement/addProduct',
      setProductIndex: 'LocationManagement/setProductIndex',
      removeProduct: 'LocationManagement/removeProduct',
      setCurrentStep: 'LocationManagement/setCurrentStep',
      setOrigin: 'LocationManagement/setOrigin',
      setDestination: 'LocationManagement/setDestination',
      setDefault: 'LocationManagement/setDefault',
      removeProductByCode: 'LocationManagement/removeProductByCode',
      clearDestination: 'LocationManagement/clearDestination'
    })
  }
})
export default class MoveLocation extends Vue {
  productService = new ProductProvider()

  stockLocationService = new StockLocationProvider()

  products!: any

  currentStep!: any

  origin!: any

  destination!: any

  setProduct!: any

  setProductIndex!: any

  removeProductByCode!: any

  addProduct!: any

  removeProduct!: any

  setCurrentStep!: any

  setOrigin!: any

  setDestination!: any

  clearDestination!: any

  setDefault!: any

  selectBranch!: any

  loadingLocation = false

  loadingProduct = false

  loadingMove = false

  get totalSkuAndTotalQty (): any {
    return {
      totalSku: this.products.length,
      totalQty: this.products.reduce((sum: number, item: any) => sum + item.qty, 0)
    }
  }

  mounted (): void {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const _this = this
    onScan.attachTo(document, {
      suffixKeyCodes: [13],
      reactToPaste: true,
      onScan (sCode) {
        const patternUrl = /^(https:\/\/www\.gentlewomanonline\.com\/|https:\/\/gentlewomanonline\.com\/|https:\/\/www\.matter-makers\.com\/|https:\/\/matter-makers\.com\/)/
        const patternLocation = /^location::/
        if (patternUrl.test(sCode.toLowerCase())) {
          const splitCodeFromUrl = sCode.split('/')
          const code = splitCodeFromUrl[splitCodeFromUrl.length - 1]
          if (code) _this.addToMoveList(code)
        } else if (patternLocation.test(sCode)) {
          _this.getLocation(sCode.split('::')[1])
        } else {
          _this.$buefy.toast.open({ message: 'QR Code นี้ไม่สามารถใช้งานได้', type: 'is-danger' })
        }
      },
      keyCodeMapper (oEvent: any) {
        if (keyCodeMapperCharacter[+oEvent.keyCode] !== undefined) {
          return keyCodeMapperCharacter[+oEvent.keyCode][+oEvent.shiftKey]
        }
        return onScan.decodeKeyEvent(oEvent)
      }
    })
  }

  async getLocation (locationId: string): Promise<void> {
    try {
      this.loadingLocation = true
      const { data } = await this.stockLocationService.getLocationById(locationId, {
        warehouse: this.selectBranch.warehouse.id
      })
      if (data) {
        if (this.currentStep === 'scan_origin' || (this.currentStep === 'scan_product' && !this.products.length)) {
            this.setOrigin(data)
            this.setCurrentStep('scan_product')
        } else if (this.currentStep === 'scan_destination') {
            if (data.id !== this.origin.id) {
                this.setDestination(data)
            } else {
                this.$buefy.toast.open({ message: 'Location ปลายทางไม่สามารถซ้ำกับต้นทางได้', type: 'is-danger' })
            }
        } else if (this.currentStep === 'summary') {
          this.$buefy.toast.open({ message: 'หากต้องการเปลี่ยน Location กรุณากดกลับเพื่อดำเนินการต่อ', type: 'is-danger' })
        } else {
          this.$buefy.toast.open({
            message: 'ไม่สามารถเปลี่ยน Location ต้นทางได้ขณะมีสินค้าอยู่ กรุณาลบสินค้า หรือ กดยกเลิกเพื่อเริ่มใหม่', type: 'is-danger'
          })
        }
      } else {
        this.$buefy.toast.open({ message: 'Location นี้ไม่อยู่ใน Warehouse ที่คุณเลือก', type: 'is-danger' })
      }
    } catch (error) {
      this.$buefy.toast.open({ message: 'เกิดข้อผิดพลาดในการดึงข้อมูล location', type: 'is-danger' })
    } finally {
      this.loadingLocation = false
    }
  }

  async addToMoveList (code: string): Promise<void> {
    let errorMsg = ''
    if (this.currentStep === 'scan_origin' && !this.origin) {
      errorMsg = 'กรุณาสแกน QR Code ของ Location ต้นทาง'
    } else if (this.currentStep === 'scan_destination' || this.currentStep === 'summary') {
      errorMsg = 'หากต้องการแก้ไข หรือเพิ่ม สินค้า กรุณากดกลับไปยังหน้าสแกนสินค้า'
    }

    if (errorMsg) {
      this.$buefy.toast.open({ message: errorMsg, type: 'is-danger' })
      return
    }

    const isExistingIndex = this.products.findIndex((p: any) => p.code === code)
    if (isExistingIndex === -1) {
      try {
        const productInfo = await this.getProductInfo(code)
        if (productInfo) {
          this.addProduct({ ...productInfo, qty: 1, timeStamp: Date.now() })
        }
      } catch (error) {
        this.$buefy.toast.open({ message: 'การดึงข้อมูลสินค้าผิดพลาด', type: 'is-danger' })
      }
    } else {
      this.setProductIndex({
        ...this.products[isExistingIndex],
        qty: this.products[isExistingIndex].qty += 1,
        timeStamp: Date.now()
      })
    }
  }

  saveMapping (): void {
    this.$buefy.dialog.alert({
      title: 'บันทึกการย้าย Location สินค้า',
      message: 'ต้องการบันทึกการย้าย Location สินค้าหรือไม่',
      confirmText: 'บันทึก',
      cancelText: 'ยกเลิก',
      canCancel: true,
      onConfirm: () => {
        this.moveLocation()
      },
      type: 'is-info',
      hasIcon: true
    })
  }

  // eslint-disable-next-line class-methods-use-this
  async moveLocation (): Promise<void> {
    try {
      this.loadingMove = true
      await this.stockLocationService.moveLocation({
        warehouse: this.selectBranch.warehouse,
        productSkus: this.products.map((p: any) => ({ qty: p.qty, code: p.code })),
        origin: this.origin.id,
        destination: this.destination.id
      })
      this.$buefy.toast.open({ message: 'การย้าย location สินค้าสำเร็จ', type: 'is-success' })
      this.setDefault()
    } catch (error) {
      this.$buefy.toast.open({ message: 'การย้าย location สินค้าผิดพลาด', type: 'is-danger' })
    } finally {
      this.loadingMove = false
    }
  }

  // eslint-disable-next-line class-methods-use-this
  defaultEmptyObject (obj: any, key: string, defaultValue: string): string {
    return obj && obj[key] ? obj[key] : defaultValue
  }

  incrementItem (product: any): void {
    let { qty } = product
    this.setProductIndex({
      ...product,
      qty: qty += 1
    })
  }

  decrementItem (product: any): void {
    if (product.qty === 1) {
        this.$buefy.dialog.confirm({
            message: 'ต้องการลบสินค้านี้หรือไม่',
            canCancel: true,
            confirmText: 'ยืนยัน',
            cancelText: 'ยกเลิก',
            type: 'is-danger',
            onConfirm: async () => {
              this.removeProductByCode(product.code)
            }
        })
    } else {
      let { qty } = product
      this.setProductIndex({
        ...product,
        qty: qty -= 1
      })
    }
  }

  removeItem (code: string): void {
    this.$buefy.dialog.confirm({
        message: 'ต้องการลบสินค้านี้หรือไม่',
        canCancel: true,
        confirmText: 'ยืนยัน',
        cancelText: 'ยกเลิก',
        type: 'is-danger',
        onConfirm: async () => {
          this.removeProductByCode(code)
        }
    })
  }

  async getProductInfo (code: string): Promise<any> {
    // get from api
    try {
      this.loadingProduct = true
      const { data: productSku } = await this.productService.getProductByCode({
        skuCodes: [code]
      })
      const productInfo = productSku?.length ? productSku[0] : null
      if (productInfo) {
        return productInfo
      }
      this.$buefy.toast.open({ message: 'QR Code นี้ไม่สามารถใช้งานได้', type: 'is-danger' })
    } catch (error) {
      this.$buefy.toast.open({ message: 'เกิดข้อผิดพลาดในการดึงข้อมูลสินค้า', type: 'is-danger' })
    } finally {
      this.loadingProduct = false
    }
    return null
  }

  onCancel (): void {
    this.$buefy.dialog.confirm({
        message: 'ต้องการยกเลิกการย้าย Location สินค้าหรือไม่',
        canCancel: true,
        confirmText: 'ต้องการ',
        cancelText: 'ไม่ต้องการ',
        type: 'is-danger',
        onConfirm: async () => {
            this.setDefault()
        }
    })
  }

  // eslint-disable-next-line class-methods-use-this
  beforeDestroy (): void {
    onScan.detachFrom(document)
  }
}
